var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconCode(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    stroke: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Raggruppa 4744",
    transform: "translate(-1650 -295.834)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Raggruppa 4743",
    transform: "translate(1652 299.834)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "inherit"
    },
    "data-name": "Tracciato 210",
    d: "M1219,849.454a4.028,4.028,0,0,1,4.379-4.592",
    transform: "translate(-1218.979 -844.862)",
    fill: "none",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "inherit"
    },
    "data-name": "Tracciato 214",
    d: "M1219,844.862a4.028,4.028,0,0,0,4.379,4.592",
    transform: "translate(-1218.979 -835.122)",
    fill: "none",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "inherit"
    },
    "data-name": "Tracciato 213",
    d: "M1223.358,849.454a4.028,4.028,0,0,0-4.379-4.592",
    transform: "translate(-1203.524 -844.862)",
    fill: "none",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "inherit"
    },
    "data-name": "Tracciato 215",
    d: "M1223.358,844.862a4.028,4.028,0,0,1-4.379,4.592",
    transform: "translate(-1203.524 -835.122)",
    fill: "none",
    strokeLinecap: "round",
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Raggruppa 4745",
    transform: "translate(35.521 -6.166)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "inherit"
    },
    "data-name": "Tracciato 216",
    d: "M-1359.467,1736.166h2.739",
    transform: "translate(2979 -1423)",
    fill: "none",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "inherit"
    },
    "data-name": "Tracciato 217",
    d: "M-1359.467,1736.166h1.451",
    transform: "translate(2984.437 -1423)",
    fill: "none",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "inherit"
    },
    "data-name": "Tracciato 218",
    d: "M-1359.466,1736.166h3.964",
    transform: "translate(2988.71 -1423)",
    fill: "none",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCode);
export default __webpack_public_path__ + "static/media/icon_code.acdb85a7c7a4b281218d7e09060c4cae.svg";
export { ForwardRef as ReactComponent };